import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ContentListsComponent } from './content-lists/content-lists.component';
import { CreateContentListComponent } from './create-content-list/create-content-list.component';
import { EditContentListComponent } from './edit-content-list/edit-content-list.component';
import { CanDeactivateGuard } from '../core/guards/can-deactivate.guard';

const routes: Routes = [
  { path: '', component: ContentListsComponent },
  { path: 'create', component: CreateContentListComponent },
  {
    path: ':id',
    component: EditContentListComponent,
    canDeactivate: [CanDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContentListManagementRoutingModule {}
